{
  "name": "factorization",
  "version": "1.0.0",
  "author": "Mathieu CAROFF <mathieu.caroff@free.fr>",
  "repository": {
    "type": "git",
    "url": "https://github.com/mathieucaroff/keyboardtranslator.git"
  },
  "license": "CC0-1.0",
  "source": "src/index.html",
  "scripts": {
    "check": "tsc --noEmit",
    "checkwatch": "tsc --noEmit --watch",
    "build": "parcel build --dist-dir public",
    "mcabuild": "parcel build --public-url keyboardtranslator.d",
    "serve": "parcel"
  },
  "devDependencies": {
    "@types/react": "^17.0.39",
    "@types/react-dom": "^17.0.11",
    "parcel": "^2.3.2",
    "prettier": "^2.5.1",
    "process": "^0.11.10",
    "typescript": "^4.5.5"
  },
  "dependencies": {
    "antd": "^4.18.9",
    "react": "^17.0.2",
    "react-dom": "^17.0.2"
  }
}
